import { Component } from '@angular/core';
import { BaseNetworkStatusService } from '../../../core/services/base-network-status.service';

@Component({
  selector: 'base-no-connection-banner',
  templateUrl: './base-no-connection-banner.component.html',
})
export class BaseNoConnectionBannerComponent {
  constructor(private networkStatusService: BaseNetworkStatusService) {}

  get isOffline() {
    return this.networkStatusService.isOnline$;
  }
}
